import { useEffect } from 'react';

export function useTokenHandler() {
    useEffect(() => {
        // Check if there are URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        
        if (urlToken) {
            // If token exists in URL, store it and other params
            const params = {
                token: urlToken,
            };
            
            // Store in localStorage
            localStorage.setItem('appParams', JSON.stringify(params));
            
            // Clean up the URL by removing all query parameters
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, '', cleanUrl);
        }
    }, []); // Empty dependency array means this runs once on mount
} 